import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@agconnections/grow-ui';
import CheckIcon from '@material-ui/icons/Check';

import './index.css';

const StepHeader = ({
  title,
  description,
  unmatchCount = 0,
  isMatchCountVisible = false,
  isLoading = false,
  allIgnored = false
}) => {
  const renderStatusTag = () => {
    if (isLoading && isMatchCountVisible) {
      return <Spinner size="sm" />;
    }

    if (allIgnored) {
      return (
        <div className="matches-label all-ignored rounded-lg" key="all-ignored">
          <div className="text-base mr-2 ml-2 text-gray-700">
            <span className="font-bold" data-testid="all-ignored">
              All Ignored
            </span>
          </div>
        </div>
      );
    }

    if (unmatchCount === 0) {
      return (
        <div
          className="matches-label all-matched rounded-lg"
          data-testid="all-matched"
          key="unmatched-properties-length"
        >
          <CheckIcon
            style={{
              marginLeft: '7px',
              fontSize: 16,
              color: '#DFFBE8',
              backgroundColor: '#0C612C',
              borderRadius: '50%'
            }}
          />
          <span className="text-base mr-2 ml-2 font-thin text-green-900">
            All Matched
          </span>
        </div>
      );
    }

    return (
      <div
        className="matches-label missing-matches rounded-lg"
        data-testid="unmatched-properties"
        key="unmatched-properties-length"
      >
        <div className="text-base mr-2 ml-2 text-yellow-700">
          <span className="font-bold" data-testid="unmatched-properties-count">
            {Math.max(unmatchCount, 0)}
          </span>
          <span className="font-thin"> Unmatched</span>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="top-header" className="p-3 w-full grid grid-cols-12">
      <div className="col-span-9">
        <div className=" flex h-10 mb-2 items-center font-semibold">
          <p className="text-xl">{title}</p>
        </div>
        <div className="justify-self-start">
          <p className="font-normal text-sm ">{description}</p>
        </div>
      </div>
      <div className="col-span-3 mt-5 flex justify-end">
        {renderStatusTag()}
      </div>
    </div>
  );
};

StepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  unmatchCount: PropTypes.number,
  isMatchCountVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  allIgnored: PropTypes.bool
};

export default StepHeader;
